import { render, staticRenderFns } from "./LikeRepostComment.vue?vue&type=template&id=4dabf890"
import script from "./LikeRepostComment.vue?vue&type=script&lang=js"
export * from "./LikeRepostComment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports